import { ActionReducerMap } from '@ngrx/store';
import { IAppState } from 'src/app/store/state/app.state';
import { GlobalConfigReducers } from './globalconfig.reducer';
import { routerReducer } from '@ngrx/router-store';

/**
 *All global reducers combine here
 * */
export const AppReducers: ActionReducerMap<IAppState,any>={
    router: routerReducer,
    appState: GlobalConfigReducers
}
